module.exports = __webpack_public_path__ + "static/media/pro.411cdd1e.svg";